import React, { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../firebase';
import './NewsPage.css';

const NewsPage = ({ onSelectNews }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const newsRef = ref(database, 'news');
    const unsubscribe = onValue(newsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map(key => ({ id: key, ...data[key] }));
        setNews(list.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0)));
      } else {
        setNews([]);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const formatDate = (d) => {
    if (!d) return '';
    const date = new Date(d);
    return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  return (
    <div className="news-page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Haberler</h1>
          <p className="page-hero-subtitle">Güncel haber ve duyurular</p>
        </div>
      </div>
      <div className="news-page-content">
        <div className="container">
          {loading ? (
            <div className="news-loading"><p>Yükleniyor...</p></div>
          ) : news.length === 0 ? (
            <div className="news-empty"><p>Henüz haber eklenmemiş.</p></div>
          ) : (
            <div className="news-grid">
              {news.map((item) => (
                <article
                  key={item.id}
                  className="news-card news-card-clickable"
                  onClick={() => onSelectNews && onSelectNews(item.id)}
                  onKeyDown={(e) => e.key === 'Enter' && onSelectNews && onSelectNews(item.id)}
                  role="button"
                  tabIndex={0}
                >
                  <h3 className="news-card-title">{item.title}</h3>
                  {item.date && <time className="news-card-date">{formatDate(item.date)}</time>}
                  <p className="news-card-excerpt">{item.excerpt || item.content}</p>
                  {onSelectNews && <span className="news-card-read-more">Devamını oku →</span>}
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewsPage;
